import { ConfigurationType } from 'data/types';
import { hasCondenserAwaitingAirHandlerAvailability } from 'utils/air-handler-availability';
import { hasFailedValidSystemsSource } from './failed-valid-systems-source';
import { FailedValidSystemsSource } from './ui-slice';

export type AirHandlerAvailabilityStatus = 'idle' | 'loading' | 'failed';

type AirHandlerAvailabilityState = {
  ui: {
    fetchingCondenserIds: string[];
    failedValidSystemsConfigSources: Record<string, FailedValidSystemsSource[]>;
  };
  configurations: { configurations: ConfigurationType[] };
};

// The air-handler step's single source of truth for "do we know which air
// handlers this configuration can take": idle once the options (or the full
// result) are in, loading while a request is in flight or still owed, failed
// when the last options request errored and nothing has been retried yet.
export const selectAirHandlerAvailabilityStatus = (
  state: AirHandlerAvailabilityState,
  configurationUniqueId: string | undefined
): AirHandlerAvailabilityStatus => {
  const configuration = state.configurations.configurations.find(
    (candidate) => candidate.uniqueId === configurationUniqueId
  );
  if (!configuration) return 'idle';
  if (!hasCondenserAwaitingAirHandlerAvailability(configuration.condensers)) {
    return 'idle';
  }
  const fetching = new Set(state.ui.fetchingCondenserIds);
  if (configuration.condensers.some((c) => fetching.has(c.uniqueId))) {
    return 'loading';
  }
  if (
    hasFailedValidSystemsSource(
      state.ui.failedValidSystemsConfigSources,
      configurationUniqueId,
      'options'
    )
  ) {
    return 'failed';
  }
  return 'loading';
};
